import { IconSharePwa, PlusPwa } from "assets/images";
import { useEffect, useState } from "react";
import OverlayModalCommon from "utils/settingsModal/common/OverLayModalCommon";
import useIosInstallPrompt from "./useIosInstallPrompt";
import { useBrandsConfig } from "utils/v2/BrandsConfig/BrandsConfigContext";

const InstallModal = () => {
  const { secondOverrideLogo, title } = useBrandsConfig();
  const [iosInstallPrompt, handleIOSInstallDeclined] = useIosInstallPrompt();
  const [timeOutPwa, setTimeOutPwa] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setTimeOutPwa(true);
    }, 3000);
  }, [timeOutPwa]);
  if (!iosInstallPrompt) {
    return null;
  } else {
    if (timeOutPwa) {
      return (
        <OverlayModalCommon
          onClose={handleIOSInstallDeclined}
          open={iosInstallPrompt}
        >
          <div className="pwaModalContainerIOS">
            <img className="logoImgPwa" src={secondOverrideLogo} alt={title} />
            <div className="textPwa">
              نسخه وب اپلیکیشن (PWA) {title} GPS را به صفحه اصلی اضافه کنید
            </div>
            <div className="flexPwa">
              <div className="textPwaFont">
                1. روی دکمه <span className="spanPwa">Share </span>در نوار پایین
                کلیک کنید
              </div>
              <div>
                <img
                  className="IconSharePwa"
                  src={IconSharePwa}
                  alt="PlusPwa"
                />
              </div>
            </div>
            <div className="flexPwa">
              <div className="textPwaFont">
                2. گزینه <span className="spanPwa">Add to Home Screen </span>را
                فعال کنید
              </div>
              <div>
                <img className="PlusPwa" src={PlusPwa} alt="PlusPwa" />
              </div>
            </div>
            <div className="flexPwa">
              <div className="textPwaFont">
                3. در قسمت بالا روی <span className="spanPwa">Add </span>کیلیک
                کنید
              </div>
              <div className="addPwa">Add</div>
            </div>
            <div onClick={handleIOSInstallDeclined} className="containerBtnPwa">
              <div className="textBtnPwa">متوجه شدم!</div>
            </div>
          </div>
        </OverlayModalCommon>
      );
    } else {
      return null;
    }
  }
};

export default InstallModal;
